<template>
  <div
    class="flex flex-row rounded-md border px-1 py-0.5 text-left font-semibold select-none"
    :class="{
      'cursor-not-allowed bg-gray-200 text-slate-400': disabled,
      'cursor-pointer bg-primary text-contrast-primary': !disabled && selected,
      'cursor-pointer bg-primary-100': !disabled && !selected
    }"
  >
    <div class="flex aspect-square h-8 flex-row items-center justify-center">
      <FontAwesomeIcon
        :icon="['fal', selected ? 'check-square' : 'square']"
        size="lg"
      />
    </div>
    <div class="flex flex-1 flex-row items-center pr-4 text-xs capitalize">
      {{ label }}
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'PermissionButton',
  components: { FontAwesomeIcon },
  props: {
    guardType: {
      type: String,
      required: true
    },
    guardName: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  }
}
</script>
